import React from "react";
import "./Counter.scss";

export default class Counter extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            count: props.count || 0,
        };
    }

    add(){
        let {count} = this.state;
        this.setState({
            count: count + 1,
        });
    }

    subtract(){
        let {count} = this.state;
        this.setState({
            count: count - 1,
        });
    }

    render() {
        return (
            <div className={'test-counter'}>
                <button onClick={() => this.add()}>+</button>
                <p>Count: {this.state.count}</p>
                <button onClick={() => this.subtract()}>-</button>
            </div>
        );
    }
}